import { render, staticRenderFns } from "./for-goods-manage-split.vue?vue&type=template&id=ad056e24&scoped=true"
import script from "./for-goods-manage-split.vue?vue&type=script&lang=js"
export * from "./for-goods-manage-split.vue?vue&type=script&lang=js"
import style0 from "./for-goods-manage-split.vue?vue&type=style&index=0&id=ad056e24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad056e24",
  null
  
)

export default component.exports